import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Users, Lock } from 'lucide-react';

const InstitutionalCard = ({ analystData, isPro }) => (
  <Card
    className={`hover:shadow-lg transition-shadow ${!isPro ? 'opacity-75' : ''}`}
    data-testid="research-institutional-card"
  >
    <CardHeader>
      <CardTitle className="flex items-center gap-2 text-lg">
        <Users className="text-purple-600" size={20} />
        Institutional Holdings
        {!isPro && <Lock size={14} className="text-gray-400" />}
      </CardTitle>
    </CardHeader>
    <CardContent>
      {isPro && analystData?.institutionalHoldings ? (
        <div className="space-y-3">
          <div className="text-center">
            <div className="text-4xl font-bold text-purple-600">{analystData.institutionalHoldings}%</div>
            <p className="text-sm text-gray-500">Institutional Ownership</p>
          </div>
        </div>
      ) : !isPro ? (
        <div className="text-center py-4">
          <Lock className="mx-auto mb-2 text-gray-400" size={24} />
          <p className="text-gray-500 text-sm">Upgrade to Pro to unlock</p>
        </div>
      ) : (
        <p className="text-gray-500 text-sm">Search for a stock to see institutional data</p>
      )}
    </CardContent>
  </Card>
);

export default InstitutionalCard;
